import { render, staticRenderFns } from "./DashboardChartWorkForce.vue?vue&type=template&id=5d4a554a&scoped=true"
import script from "./DashboardChartWorkForce.vue?vue&type=script&lang=js"
export * from "./DashboardChartWorkForce.vue?vue&type=script&lang=js"
import style0 from "./DashboardChartWorkForce.vue?vue&type=style&index=0&id=5d4a554a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4a554a",
  null
  
)

export default component.exports